/**
 * agreementVersion.ts — Version identifier of the Independent Contractor
 * Agreement currently in force.
 *
 * Every acceptance row records the version it applies to. An acceptance that
 * cannot name the text it was given demonstrates nothing later, which is why
 * `instructor_agreement_acceptances.agreement_version` is NOT NULL.
 *
 * Why an ISO date and not semver: the only two things this value has to do are
 * identify the text in force and order two acceptances. A date does both and
 * is self-explanatory to whoever reads an acceptance row years from now,
 * without needing a changelog to interpret `1.2.0`.
 *
 * There is no legal-document table and no document versioning in this repo, so
 * a constant is the smallest mechanism that makes the version auditable. Bump
 * it in the same commit as the content change in
 * `public/content/legal/independent-contractor-agreement.*.md`.
 *
 * Bumped to the Effective Date of Instructor Service Provision Agreement 1.0
 * (CKLSM-750), which replaced the placeholder document that 2026-09-01
 * labelled.
 *
 * Note: bumping this does NOT re-prompt instructors who accepted an earlier
 * version. The server-side gates ask only whether any acceptance exists —
 * re-requiring acceptance on a version change is a product decision recorded
 * as debt in spec.md's Edge Cases, not behaviour of this constant.
 */
export const ICA_VERSION = '2026-09-16';
